import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const SellingUsedGoods = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>How to sell used items in Nigeria without wahala – Naijads.ng</title>
        <meta
          name="description"
          content="Tips for selling secondhand items easily in Nigeria. Learn how to deal with price hagglers, write clean ads, and get buyers you can trust on Naijads.ng."
        />
        <link rel="canonical" href="https://naijads.ng/selling-used-goods" />
        <meta property="og:title" content="Sell Used Goods in Nigeria Without Stress – Naijads.ng" />
        <meta
          property="og:description"
          content="Naija guide to selling your used phones, cars, furniture and more. No middleman, no wahala — just free local classified listings."
        />
        <meta property="og:image" content="https://naijads.ng/assets/sell-banner.webp" />
        <meta property="og:type" content="article" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              headline: "Selling Secondhand Goods in Nigeria Without Stress",
              author: { "@type": "Organization", name: "Naijads.ng" },
              datePublished: "2025-06-25",
              image: "https://naijads.ng/assets/sell-banner.webp",
              publisher: {
                "@type": "Organization",
                name: "Naijads.ng",
                logo: {
                  "@type": "ImageObject",
                  url: "https://naijads.ng/assets/Tayo.svg"
                }
              },
              mainEntityOfPage: "https://naijads.ng/selling-used-goods"
            })
          }}
        />
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>How to sell used items in Nigeria without Wahala</h1>
          <p>
            Selling secondhand items online can bring cash, clear space, or help someone get a good deal. But let’s be honest — <strong>Nigerian buyers sabi haggle</strong>!
            From pricing stress to unserious chats, it’s easy to get tired. Don’t worry, Naijads.ng got you covered.
          </p>
          <p>
            Whether it’s your old <strong>Infinix phone</strong>, a <strong>tokunbo generator</strong>, or some nice <strong>home furniture</strong>, here’s how to list and
            sell sharp-sharp.
          </p>
        </div>

        <div className="info-block">
          <h3>Common wahala sellers Face</h3>
          <ul>
            <li><strong>Pricing stress:</strong> Person go offer ₦5,000 for your ₦30,000 phone 😅</li>
            <li><strong>No-shows:</strong> “I’m on my way” wey never reach since morning</li>
            <li><strong>Over-questioning:</strong> “Why you dey sell am?” “Any scratch?” “You get receipt?”</li>
          </ul>
          <div className="info-image-banner">
          <img
            src="/sell-banner.webp"
            alt="Naija seller chatting with buyers – Naijads illustration"
          />
        </div>
        </div>
        

        <div className="info-block">
          <h3>How to sell like a pro on Naijads.ng</h3>
          <ul>
            <li><strong>State condition clearly:</strong> Say if item is new, Naija-used, or foreign-used (tokunbo)</li>
            <li><strong>Add real photos:</strong> Light up your item and show angles — don’t use Google images</li>
            <li><strong>Be direct but respectful:</strong> “Final price na ₦15,000, bros — no go low again”</li>
            <li><strong>Choose your area:</strong> Add exact location or nearest bus stop — help buyer know if pickup make sense</li>
            <li><strong>Use WhatsApp smartly:</strong> Respond quick and follow up, but protect your privacy</li>
          </ul>
        </div>

        <div className="info-block-main">
          <h3>Good items to sell that move fast in Naija</h3>
          <ul>
            <li>Smartphones, gadgets & accessories</li>
            <li>Cars (tokunbo, Nigerian-used), bike parts</li>
            <li>Furniture (sofas, beds, kitchen items)</li>
            <li>Baby items (clothes, walkers, feeding gear)</li>
            <li>Generators, gas cookers, electronics</li>
          </ul>
        </div>

        <div className="info-block-main">
          <h3>Final advice: no be by force to sell today</h3>
          <p>
            If buyers dey play, take break. You fit repost later with adjusted price or new angle. Naijads is built to help you <strong>sell free, local and legit</strong>.
            No agents, no hidden fees, just your hustle.
          </p>
          <p><strong>Oya, ready to post? Upload your item now and watch Naija buyers roll in!</strong></p>
        </div>
      </div>
    </>
  );
};

export default SellingUsedGoods;
